<template>
  <div class="term_files">
    <fluke-card>
      <header>
        <div class="title">Gerenciar PDF Termos</div>
        <div class="description">
          Arquivos dos Termos de Privacidade e Uso de Imagem/Video
        </div>
      </header>
      <main>
        <v-data-table
          :headers="headers"
          :items="term_files"
          :rows-per-page-items="[15, 30, 60]"
          rows-per-page-text="Linhas pos página"
          class="inner-tables"
          disable-initial-sort
        >
          <template v-slot:items="props">
            <td>
              {{ props.item.name }}
              &nbsp;
              <a :href="props.item.url" target="_blank">(ver arquivo)</a>
            </td>
            <td>{{ props.item.user }}</td>
            <td>{{ props.item.term_type_label }}</td>
            <td>{{ props.item.version }}</td>
            <td>{{ props.item.created_at }}</td>
          </template>
        </v-data-table>
      </main>
      <footer>
		<fluke-button v-if="permission.write" v-on:click.native="$router.push('term_files/add')">Adicionar Novo PDF</fluke-button>
        <fluke-button @click.native="$router.push('students_terms')"
          >Voltar para lista</fluke-button
        >
        <download-excel
          class="fluke-btn export-btn"
          :data="term_files"
          :fields="json_fields"
          worksheet="PDF Termos Worksheet"
          name="pdf-termos.xls"
        >
          <i class="material-icons">get_app</i>
          Download XLS
        </download-excel>
      </footer>
    </fluke-card>
  </div>
</template>

<script>
import axios from "axios";
import Card from "../../components/Main/Content/Card/Card.vue";
import Button from "../../components/Main/Content/Button/Button.vue";
import permission from "../../mixins/permissions";

export default {
  mixins: [permission],
  components: {
    "fluke-card": Card,
    "fluke-button": Button,
  },
  data: function () {
    return {
      term_files: [],
      headers: [
        {
          text: "Nome do arquivo",
          align: "left",
          value: "first_name",
        },
        {
          text: "Cadastrado por",
          align: "left",
          value: "user",
        },
        {
          text: "Tipo do Termo",
          align: "left",
          value: "term_type_label",
        },
        {
          text: "Versão",
          align: "left",
          value: "version",
        },
        {
          text: "Data do Cadastro",
          align: "left",
          value: "orignal_created_at",
        },
      ],
      json_fields: {
        dbID: "id",
        "Nome do arquivo": "name",
        "URL do arquivo": "url",
        "Tipo do Termo": "term_type_label",
        "Cadastrado por": "user",
        "Data do Cadastro": "created_at",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      permission: {
        read: false,
        write: false,
      },
    };
  },
  created: function () {
    const defaultPermissions = { read: false, write: false };
    this.permission = this.getUserPagePermission("term_files");
    if (!this.permission) {
      this.permission = { ...defaultPermissions };
    }

    if (this.permission.read == false) {
      this.$router.push("/");
    }

    this.get();
  },
  methods: {
    get: async function () {
      axios
        .get(this.$myServerAddresses.courses + "term_files", {
          headers: {
            "X-Fluke": this.$cookies.get("token"),
          },
        })
        .then((result) => {
          this.term_files = result.data.map(this.formatData);
        });
    },
    formatData(elem) {
      const formatDate = (value, withHour = true) => {
        let newData = value.slice(0, -8).split("T");
        newData =
          newData[0].split("-").reverse().join("/") +
          (withHour ? " " + newData[1] : "");
        return newData;
      };
      elem.orignal_created_at = elem.created_at;
      elem.created_at = formatDate(elem.created_at);
      elem.url = `${this.$myServerAddresses.courses}terms/${elem.name}`;
      elem.term_type_label = this.convertTermType(elem.term_type);
      return elem;
    },
    convertTermType(termType) {
      const values = {
        1: "Privacidade",
        2: "Uso de Image/Video",
      };
      return values[termType];
    },
  },
};
</script>
